import React from 'react';
import i18next from 'i18next';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { string } from 'prop-types';

import { snakeToCamel } from '~utils/string';

import { CHANNEL_ICONS, MERCAT_CHANNEL } from '../ChannelInfo/constants';

function ChannelBox({ channel }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <Tooltip
        title={`
        ${channel !== MERCAT_CHANNEL ? i18next.t(`DeliveryStatus:app`) : ''}
        ${i18next.t(`DeliveryStatus:${CHANNEL_ICONS[snakeToCamel(channel)].appName}`)}
      `}
        placement="top"
        arrow>
        <img
          src={CHANNEL_ICONS[snakeToCamel(channel)].icon}
          alt={CHANNEL_ICONS[snakeToCamel(channel)].appName}
          width="32"
          height="32"
        />
      </Tooltip>
    </Box>
  );
}

ChannelBox.propTypes = {
  channel: string.isRequired
};

export default ChannelBox;
